import { useParams } from "react-router-dom";
import { Tabs } from "antd";
import LeaveTab from "./tabs/LeaveTab";
import HolidayTab from "./tabs/HolidayTab";
import SicknessTab from "./tabs/SicknessTab";
import StatutoryTab from "./tabs/StatutoryTab";
import TimesheetsTab from "./tabs/TimesheetsTab";
import NMWTab from "./tabs/NMWTab";
import PensionTab from "./tabs/PensionTab";

export default function HRPage() {
  const { companyId } = useParams<{ companyId: string }>();
  const cid = Number(companyId);

  const items = [
    { key: "leave", label: "Leave Requests", children: <LeaveTab cid={cid} /> },
    { key: "holiday", label: "Holiday Entitlements", children: <HolidayTab cid={cid} /> },
    { key: "sickness", label: "Sickness Absence", children: <SicknessTab cid={cid} /> },
    { key: "statutory", label: "Statutory Pay", children: <StatutoryTab cid={cid} /> },
    { key: "timesheets", label: "Timesheets", children: <TimesheetsTab cid={cid} /> },
    { key: "nmw", label: "NMW / Compliance", children: <NMWTab cid={cid} /> },
    { key: "pension", label: "Pension", children: <PensionTab cid={cid} /> },
  ];

  return (
    <div>
      <div className="mb-4">
        <h1 className="text-xl font-bold text-slate-800">HR & Payroll</h1>
        <p className="text-slate-500 text-sm">Company ID: {cid}</p>
      </div>
      <div className="bg-white rounded-xl shadow-sm border border-slate-100 p-4">
        <Tabs items={items} size="small" />
      </div>
    </div>
  );
}
